<template>
  <div aria-hidden="true" class="mesh-backdrop">
    <div class="mesh-layer mesh-layer-a" />
    <div class="mesh-layer mesh-layer-b" />
    <div class="mesh-layer mesh-layer-c" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "MeshBackdrop",
});
</script>

<style lang="scss" scoped>
.mesh-backdrop {
  pointer-events: none;
  position: fixed;
  inset: 0;
  z-index: -10;
  overflow: hidden;
}

.mesh-layer {
  position: absolute;
  background-size: 120% 120%;
}

.mesh-layer-a {
  inset: -20%;
  opacity: 0.52;
  mix-blend-mode: multiply;
  background: radial-gradient(
    45% 55% at 20% 35%,
    var(--brand-primary) 0%,
    transparent 70%
  );
}

.mesh-layer-b {
  inset: -20%;
  opacity: 0.48;
  mix-blend-mode: multiply;
  background: radial-gradient(
    50% 50% at 75% 55%,
    var(--brand-secondary) 0%,
    transparent 72%
  );
  background-size: 130% 130%;
}

.mesh-layer-c {
  inset: -15%;
  opacity: 0.4;
  mix-blend-mode: multiply;
  background: radial-gradient(
    35% 40% at 50% 15%,
    var(--brand-accent) 0%,
    transparent 70%
  );
  background-size: 110% 110%;
}
</style>

<style lang="scss">
html.dark .mesh-backdrop .mesh-layer-a {
  opacity: 0.75;
  mix-blend-mode: lighten;
}

html.dark .mesh-backdrop .mesh-layer-b {
  opacity: 0.65;
  mix-blend-mode: lighten;
}

html.dark .mesh-backdrop .mesh-layer-c {
  opacity: 0.5;
  mix-blend-mode: lighten;
}
</style>
